import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from '../config/api';
import { API_URL } from '../config/api';
import Logo from '../components/Logo';

function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      if (!token) {
        setStatus('error');
        setMessage('Invalid verification link. No token provided.');
        return;
      }

      try {
        const response = await axios.get(`${API_URL}/api/email/verify/${token}`);
        setStatus('success');
        setMessage(response.data.message);
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.detail || 'Verification failed. Please try again.');
      }
    };

    verifyEmail();
  }, [token]);

  return (
    <div className="min-h-screen bg-gradient-civote flex items-center justify-center p-4">
      <div className="bg-white rounded-card shadow-card w-full max-w-md p-8 text-center" data-testid="verify-email-page">
        <div className="flex flex-col items-center mb-6">
          <Logo size="large" />
        </div>

        {status === 'verifying' && (
          <div className="py-8">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
            <p className="text-gray-600 font-rubik">Verifying your email...</p>
          </div>
        )}

        {status === 'success' && (
          <div className="py-8" data-testid="verification-success">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2 font-rubik">Email Verified!</h2>
            <p className="text-gray-600 font-rubik mb-6">{message}</p>
            <Link 
              to="/profile" 
              className="btn-primary inline-block"
              data-testid="go-to-profile-btn"
            >
              Go to Profile
            </Link>
          </div>
        )}

        {status === 'error' && (
          <div className="py-8" data-testid="verification-error">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2 font-rubik">Verification Failed</h2>
            <p className="text-red-600 font-rubik mb-6">{message}</p>
            <div className="space-y-3">
              <Link 
                to="/profile" 
                className="btn-secondary inline-block w-full"
                data-testid="try-again-btn"
              >
                Go to Profile to Resend
              </Link>
              <Link 
                to="/" 
                className="text-gray-500 hover:text-gray-700 block font-rubik"
              >
                Back to Login
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default VerifyEmailPage;
